module.exports = __webpack_public_path__ + "static/atelier_sp-ed5d27e1450b8579bea59ebdda62c968.png";